import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from 'src/app/core/guards/auth-guard.service';
import { ApiReferenceNavigationComponent } from './apireference-navigation/apireference-navigation.component';
import { ApireferenceComponent } from './apireference.component';
import { DocumentationViewComponent } from 'src/app/core/documentation-view/documentation-view.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        component: ApiReferenceNavigationComponent,
        outlet: 'sidenav',
        data: { animation: 'isLeft' }
      },
      {
        path: '',
        component: ApireferenceComponent,
      },
      {
        path: 'introduction',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'authentication',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'apiRequests',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'apiResponses',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'gettingStarted',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'deploymentsAPI',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'cardPoolsApi',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'dataConnectorApi',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
      {
        path: 'setupApi',
        component: ApireferenceComponent,
        children: [
          {
            path: '',
            component: DocumentationViewComponent,
            outlet: 'documentation'
          }
        ]
      },
    ]
  }];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class APIReferenceRoutingModule { }
  